const getTimeLeftInMillisUntil = (endDate?: string) => {
  if (!endDate) {
    return 0;
  }
  const timeLeft = new Date(endDate).getTime() - Date.now();
  return timeLeft < 0 ? 0 : timeLeft;
};

export default getTimeLeftInMillisUntil;
